import { Palette } from "../../../../constants/palettes";
import { memo, useCallback } from 'react';
import { useCookieBannerHeight } from "../../../cookie-banner";
import Button, { ButtonSize } from "../../../button";
import { MegaMenuType } from "../../constants";
import { useMenuContext } from "../../mega-menu-provider";
import { AuthLinksContainer } from "./auth-links.styles";
import { jsx as _jsx } from "react/jsx-runtime";
export var AuthLinks = /*#__PURE__*/memo(function (_ref) {
  var palette = _ref.palette,
    isMobileMenuOpen = _ref.isMobileMenuOpen,
    isMinimalMenu = _ref.isMinimalMenu,
    ctas = _ref.ctas;
  var cookieBannerHeight = useCookieBannerHeight() || 0;
  var _useMenuContext = useMenuContext(),
    isMobileMenu = _useMenuContext.isMobileMenu;
  var handleCtaClick = useCallback(function (onClickHandler) {
    return function (event) {
      if (!onClickHandler) {
        return;
      }
      var menuType = MegaMenuType.Desktop;
      if (isMinimalMenu) {
        menuType = MegaMenuType.Mimimal;
      } else if (isMobileMenu) {
        menuType = MegaMenuType.Mobile;
      }
      onClickHandler === null || onClickHandler === void 0 ? void 0 : onClickHandler(event, {
        menuType: menuType
      });
    };
  }, [isMobileMenu, isMinimalMenu]);
  return /*#__PURE__*/_jsx(AuthLinksContainer, {
    isMobileMenuOpen: isMobileMenuOpen,
    cookieBannerHeight: cookieBannerHeight,
    isMinimalMenu: isMinimalMenu,
    children: ctas.map(function (_ref2) {
      var variant = _ref2.variant,
        label = _ref2.label,
        onClick = _ref2.onClick,
        link = _ref2.link,
        dataQa = _ref2.dataQa;
      return /*#__PURE__*/_jsx(Button, {
        variant: variant,
        href: link,
        size: ButtonSize.Medium,
        hasMinWidth: false,
        palette: isMobileMenuOpen ? Palette.Negative : palette,
        onClick: handleCtaClick(onClick),
        "data-gtm-event": "cta_button",
        "data-qa": dataQa,
        children: label
      }, link);
    })
  });
});